import { CouponPaymentDetail } from "./coupon-payment-detail";

export class CouponPayment {

    refNo: string;
    amount: number = 0;
    fromLocationCode: number;
    couponPaymentDetails: CouponPaymentDetail[] = [];
}
